module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-plumbing.svg?3c156af3a752444c6b86948227778205";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-plumbing.svg
// module id = 1040
// module chunks = 1